// The back end keeps a canvas scene as a JSON string ("" for an untouched canvas); an
// object is taken as is. An unreadable scene opens the canvas as it was built.
export const parseScene = (scene) => {
  if (!scene) return null;
  if (typeof scene === "object") return scene;
  try {
    return JSON.parse(scene);
  } catch (error) {
    return null;
  }
};
